import { useEffect, useState } from "react";
import { format, isValid, parse } from "date-fns";

const maskDate = (raw) => {
  const d = raw.replace(/\D/g, "").slice(0, 8);
  return d.length <= 2 ? d : d.length <= 4 ? `${d.slice(0, 2)}/${d.slice(2)}` : `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
};
const toDisplay = (iso) => (iso ? format(new Date(iso + "T00:00:00"), "dd/MM/yyyy") : "");

// Saisie française rapide JJ/MM/AAAA (12092026 → 12/09/2026), clavier numérique, validation réelle (bissextiles).
// mode: "birth" (pas de futur) | "future" (aujourd'hui ou plus tard, alerte si passé) | "any". Émet un ISO yyyy-MM-dd ou "".
export function FrDateInput({ value, onChange, mode = "any", testid = "fr-date", placeholder = "JJ/MM/AAAA", className = "", autoFocus = false, onValidity }) {
  const [text, setText] = useState(toDisplay(value));
  const [err, setErr] = useState("");
  useEffect(() => { setText(toDisplay(value)); }, [value]);
  const today = new Date(); today.setHours(0, 0, 0, 0);

  const commit = (t) => {
    if (!t) { setErr(""); onChange(""); onValidity?.(true); return; }
    if (t.length < 10) { setErr("Format attendu : JJ/MM/AAAA"); onValidity?.(false); return; }
    const d = parse(t, "dd/MM/yyyy", new Date());
    if (!isValid(d) || format(d, "dd/MM/yyyy") !== t) { setErr("Date invalide (ex. 31/02)"); onValidity?.(false); return; }
    if (mode === "birth" && d > today) { setErr("La date de naissance ne peut pas être dans le futur"); onValidity?.(false); return; }
    if (mode === "birth" && d.getFullYear() < today.getFullYear() - 120) { setErr("Date trop ancienne"); onValidity?.(false); return; }
    if (mode === "future" && d < today) { setErr("Attention : cette date est déjà passée"); onChange(format(d, "yyyy-MM-dd")); onValidity?.(false); return; }
    setErr(""); onChange(format(d, "yyyy-MM-dd")); onValidity?.(true);
  };

  return (
    <div className={className}>
      <input data-testid={testid} type="text" inputMode="numeric" placeholder={placeholder} maxLength={10} autoFocus={autoFocus}
        autoComplete={mode === "birth" ? "bday" : "off"} value={text} aria-invalid={!!err} aria-label={`Date (${placeholder})`}
        onChange={(e) => { const m = maskDate(e.target.value); setText(m); if (m.length === 10) commit(m); else { if (err) setErr(""); if (!m) onChange(""); } }}
        onBlur={() => commit(text)}
        className={`h-12 w-full rounded-lg border bg-white px-3 text-slate-800 font-semibold tracking-wide text-base focus:outline-none focus:ring-2 focus:ring-accent-300 ${err ? "border-red-400" : "border-slate-200"}`} />
      {err && <p data-testid={`${testid}-error`} className={`text-xs mt-1 font-semibold ${err.startsWith("Attention") ? "text-orange-600" : "text-red-600"}`}>{err}</p>}
    </div>
  );
}

const maskTime = (raw) => {
  const d = raw.replace(/\D/g, "").slice(0, 4);
  return d.length <= 2 ? d : `${d.slice(0, 2)}:${d.slice(2)}`;
};

// Saisie heure rapide HH:MM (0930 → 09:30), clavier numérique. Émet "HH:MM" ou "".
export function FrTimeInput({ value, onChange, testid = "fr-time", className = "", placeholder = "HH:MM" }) {
  const [text, setText] = useState(value || "");
  const [err, setErr] = useState("");
  useEffect(() => { setText(value || ""); }, [value]);
  const commit = (t) => {
    if (!t) { setErr(""); onChange(""); return; }
    if (t.length < 5) { setErr("Format attendu : HH:MM"); return; }
    const [h, m] = t.split(":").map(Number);
    if (h > 23 || m > 59) { setErr("Heure invalide"); return; }
    setErr(""); onChange(t);
  };
  return (
    <div className={className}>
      <input data-testid={testid} type="text" inputMode="numeric" placeholder={placeholder} maxLength={5} value={text} aria-invalid={!!err} aria-label="Heure (HH:MM)"
        onChange={(e) => { const m = maskTime(e.target.value); setText(m); if (m.length === 5) commit(m); else { if (err) setErr(""); if (!m) onChange(""); } }}
        onBlur={() => commit(text)}
        className={`h-12 w-full rounded-lg border bg-white px-3 text-slate-800 font-semibold tracking-wide text-base focus:outline-none focus:ring-2 focus:ring-accent-300 ${err ? "border-red-400" : "border-slate-200"}`} />
      {err && <p data-testid={`${testid}-error`} className="text-xs text-red-600 mt-1 font-semibold">{err}</p>}
    </div>
  );
}
